import { post, get, put, deleteApi } from './axiosFun';
// 个人练习题列表
export const personalQuestionList = (courseCategoryId) => { return get(`/edu/practice/personalQuestionList/${courseCategoryId}`) };

// 个人练习题删除(重置)
export const personalQuestionRemove = (courseCategoryId) => { return deleteApi(`/edu/practice/personalQuestionRemove/${courseCategoryId}`) };

// 个人练习题提交
export const personalQuestionSubmit = (params) => { return put("/edu/practice/personalQuestionSubmit",params) };


// WEBPACK FOOTER //
// ./src/api/exercise.js